import React, { useEffect, useRef, useState } from 'react';

const LiteDashboard = ({ activeTab, tabContent }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const loadTimeoutRef = useRef(null);

    useEffect(() => {
      setIsLoaded(false);

      return () => {
        if (loadTimeoutRef.current) {
          clearTimeout(loadTimeoutRef.current);
        }
      };
    }, [tabContent]);

    const handleLoad = () => {
      loadTimeoutRef.current = setTimeout(() => {
        setIsLoaded(true);
      }, 500);
    };

    return (
      <>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            overflow: "hidden",
          }}
        >
          {!isLoaded && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#111217",
                zIndex: 1,
              }}
              role="status"
              aria-label="Dashboard loading"
            >
              <div
                aria-hidden="true"
                style={{
                  width: "28px",
                  height: "28px",
                  border: "3px solid rgba(255, 255, 255, 0.25)",
                  borderTopColor: "#fff",
                  borderRadius: "50%",
                  animation: "lite-dashboard-spin 0.8s linear infinite",
                }}
              />
            </div>
          )}
          <iframe
            key={tabContent}
            src={tabContent}
            width="100%"
            height="100%"
            style={{
              flexGrow: 1,
              border: "none",
              visibility: isLoaded ? "visible" : "hidden",
              opacity: isLoaded ? 1 : 0,
              transition: "opacity 0.4s ease-in-out",
            }}
            loading="eager"
            onLoad={handleLoad}
            title={`${activeTab || "Dashboard"} dashboard`}
            allowFullScreen
          />
        </div>
      </>
    )
  
};

export default LiteDashboard;
